/**
 * Firebase Auth 래퍼
 *
 * - createAccount: 일반 이메일/비밀번호 가입
 * - createAccountWithUID: 학생·강사 등록 시 Firestore 문서 ID와 Auth UID를 일치시키기 위해 Functions 호출
 */
import { useNavigate } from "react-router-dom";
import useFirebaseConfig from "./useFirebaseConfig";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, deleteUser} from "firebase/auth";

const useFirebaseAuth = () => {
    const navigate = useNavigate();
    const {auth} = useFirebaseConfig();

    const createAccount = async(email:string, password:string) => {
      const result = await createUserWithEmailAndPassword(auth, email, password).then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        return user;
        // ...
      })
      .catch((err) => {
        console.log(err);
        return null;
        // ..
      });
      return result;
  }

    // 학생/강사 UID를 Firestore 문서 ID와 동일하게 맞추기 위한 Functions 호출
    // firebase.json에 /api rewrite가 없으면 배포 환경에서 실패할 수 있음
    const createAccountWithUID = async (uid: string, email: string, password: string, displayName?: string) => {
      try {
        const response = await fetch('/api/createUserWithUID', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            uid,
            email,
            password,
            displayName
          }),
        });

        if (!response.ok) {
          throw new Error('계정 생성에 실패했습니다.');
        }

        const result = await response.json();
        return result;
      } catch (error) {
        console.error('계정 생성 오류:', error);
        return null;
      }
    };

    const login = async (email:string, password:string) => {
        const result = await signInWithEmailAndPassword(auth, email, password).then((userCredential) => {
          const user = userCredential.user;
          return user;
        })
        .catch((error) => {
          return error;
        });
        return result;
      }

    const logout = async () => {
        const result =  await signOut(auth).then(() => {
          navigate("/", {replace:true});  
          return true
        }).catch((error) => {
          return error;
        });
        return result;
      }

    return {createAccount, createAccountWithUID, login, logout}
}

export default useFirebaseAuth;